import { render, staticRenderFns } from "./EditTextTemplate.vue?vue&type=template&id=f5f64a26&scoped=true"
import script from "./EditTextTemplate.vue?vue&type=script&lang=js"
export * from "./EditTextTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f64a26",
  null
  
)

export default component.exports